import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { form_control, SaveReportFile } from 'projects/sepidz-web-framework/src/lib/models';
import { BaseFormComponent } from 'projects//sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component';
import { FormControlTypes } from 'projects/sepidz-web-framework/src/lib/models/form-base-control.model';
import { SelectorService } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service';
@Component({
  selector: 'report-selector',
  templateUrl: './report-selector.component.html',
  styleUrls: ['./report-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportSelectorComponent extends BaseFormComponent<SaveReportFile> {
  @Input() dataList: SaveReportFile[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
 async ngOnInit() {
    super.ngOnInit();
    this.selectorService.setDataList("Id", this.dataList);
  }
async  setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{ label: 'انتخاب گزارش', controlType: FormControlTypes.dropdown, modelName: 'Id', disabled: false, name: 'Id', order: 0, textType: 'text', formVisible: true, listVisible: true, required: true, valueMember: 'Id', displayMember: 'ReportTitle' });
    this.orignalColumns = this.columns;
  }
  onChanged($event) {
    this.result = $event;
    this.close();
  }
}
